const green = {
  300: "#aede8a",
  500: "rgb(141, 188, 105)",
  700: "#789e5c",
};

export default green;
